import CustomerReviews from './CustomerReviews';

export default CustomerReviews;
